<script>
import messages from "../../mixins/messages";
import toasts from "../../mixins/toasts";

export default Vue.extend({
  mixins: [messages, toasts],
  data() {
    return {
      modified: false,
      original: null,
      subject: null
    };
  },
  mounted() {
    this.modified = false;
  },
  methods: {
    update(subject) {
      this.modified = true;
      this.subject = subject;
      if (this.original == null) {
        this.original = {
          exams: subject.semesters.exams,
          no_exams: subject.semesters.no_exams
        };
      }
    },
    submit() {
      if (!this.modified) {
        return;
      }

      let submit = () => {
        this.modified = false;
        let loading = this.$loading.open();
        axios
          .put(`/api/subjects/${this.subject.id}`, this.subject)
          .then(response => {
            loading.close();
            this.original = response.data;
            this.subject = response.data;
            this.$refs.form.update(this.subject);
            this.toast("success", "Предмет был успешно сохранен");
          })
          .catch(error => {
            loading.close();
            switch (error.response.status) {
              case 422: {
                let errors = error.response.data.errors;
                let key = _.first(_.keys(errors));
                this.toast("warning", _.first(errors[key]));
                break;
              }
              case 403: {
                this.toast(
                  "warning",
                  "Сохранение предмета с такими параметрами недоступно"
                );
                break;
              }
              default: {
                this.modified = true;
                this.toast("error", "@unexpected", error);
                break;
              }
            }
          });
      };

      let relationsRemoved =
        _.difference(this.original.exams, this.subject.semesters.exams).length >
          0 ||
        _.difference(this.original.no_exams, this.subject.semesters.no_exams)
          .length > 0;

      if (relationsRemoved) {
        this.$dialog.confirm({
          title: "Внимание",
          message:
            "<b>Некоторые семестры предмета были удалены!</b> " +
            "Если Вы сохраните изменения, то существующие записи расписания " +
            "для удаленных семестров все еще будут ссылаться на данный предмет.",
          confirmText: "Изменить",
          cancelText: "Назад",
          type: "is-warning",
          hasIcon: true,
          onConfirm: () => {
            submit();
          }
        });
      } else {
        submit();
      }
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/subjects/Edit.vue